/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Agent_Development_Orchestration_Title13Inputs */

const en_svc_ai_agent_development_orchestration_title13 = /** @type {(inputs: Svc_Ai_Agent_Development_Orchestration_Title13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multi-agent systems`)
};

const ar_svc_ai_agent_development_orchestration_title13 = /** @type {(inputs: Svc_Ai_Agent_Development_Orchestration_Title13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أنظمة الوكلاء المتعددين`)
};

const bn_svc_ai_agent_development_orchestration_title13 = /** @type {(inputs: Svc_Ai_Agent_Development_Orchestration_Title13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`মাল্টি-এজেন্ট সিস্টেম`)
};

const de_svc_ai_agent_development_orchestration_title13 = /** @type {(inputs: Svc_Ai_Agent_Development_Orchestration_Title13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multiagentensysteme`)
};

const es_svc_ai_agent_development_orchestration_title13 = /** @type {(inputs: Svc_Ai_Agent_Development_Orchestration_Title13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sistemas multiagente`)
};

const fr_svc_ai_agent_development_orchestration_title13 = /** @type {(inputs: Svc_Ai_Agent_Development_Orchestration_Title13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Systèmes multi-agents`)
};

const pt_svc_ai_agent_development_orchestration_title13 = /** @type {(inputs: Svc_Ai_Agent_Development_Orchestration_Title13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sistemas multiagentes`)
};

const zh_svc_ai_agent_development_orchestration_title13 = /** @type {(inputs: Svc_Ai_Agent_Development_Orchestration_Title13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`多代理系统`)
};

const tr_svc_ai_agent_development_orchestration_title13 = /** @type {(inputs: Svc_Ai_Agent_Development_Orchestration_Title13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çoklu aracılı sistemler`)
};

const ru_svc_ai_agent_development_orchestration_title13 = /** @type {(inputs: Svc_Ai_Agent_Development_Orchestration_Title13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мультиагентные системы`)
};

const pl_svc_ai_agent_development_orchestration_title13 = /** @type {(inputs: Svc_Ai_Agent_Development_Orchestration_Title13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Systemy wieloagentowe`)
};

/**
* | output |
* | --- |
* | "Multi-agent systems" |
*
* @param {Svc_Ai_Agent_Development_Orchestration_Title13Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_agent_development_orchestration_title13 = /** @type {((inputs?: Svc_Ai_Agent_Development_Orchestration_Title13Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Agent_Development_Orchestration_Title13Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_agent_development_orchestration_title13(inputs)
	if (locale === "bn") return bn_svc_ai_agent_development_orchestration_title13(inputs)
	if (locale === "de") return de_svc_ai_agent_development_orchestration_title13(inputs)
	if (locale === "es") return es_svc_ai_agent_development_orchestration_title13(inputs)
	if (locale === "fr") return fr_svc_ai_agent_development_orchestration_title13(inputs)
	if (locale === "pt") return pt_svc_ai_agent_development_orchestration_title13(inputs)
	if (locale === "zh") return zh_svc_ai_agent_development_orchestration_title13(inputs)
	if (locale === "tr") return tr_svc_ai_agent_development_orchestration_title13(inputs)
	if (locale === "ru") return ru_svc_ai_agent_development_orchestration_title13(inputs)
	if (locale === "pl") return pl_svc_ai_agent_development_orchestration_title13(inputs)
	return en_svc_ai_agent_development_orchestration_title13(inputs)
});
export { svc_ai_agent_development_orchestration_title13 as "svc_ai-agent-development_ORCHESTRATION_title" }